module.exports = __webpack_public_path__ + "img/thumbnails-11-infinite-scroll-blog.60451732.png";